import React, { useState, useEffect, useCallback } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { IoClose } from "react-icons/io5";
import { Grid, Container } from "@mui/material";
import "../../style/sostenibilidad/videosos.css";

/* Importar imágenes */

import imagen1 from "../../img/sostenibilidad/video/sos.png";
import pil from "../../img/sostenibilidad/portada/pil-sost.png";
import pil1 from "../../img/sostenibilidad/portada/pil-sost-1.png";
import pilmedio1 from "../../img/sostenibilidad/portada/pil-sost-1ab.png";
import pil2 from "../../img/sostenibilidad/portada/pil-sost-2.png";
import pilmedio2 from "../../img/sostenibilidad/portada/pil-sost-2ab.png";
import pil3 from "../../img/sostenibilidad/portada/pil-sost-3.png";
import pilmedio3 from "../../img/sostenibilidad/portada/pil-sost-3ab.png";
import pil4 from "../../img/sostenibilidad/portada/pil-sost-4.png";
import pilmedio4 from "../../img/sostenibilidad/portada/pil-sost-4ab.png";
import nuevo from "../../img/sostenibilidad/portada/Logo_pilares.png"

/* const data = [
  { original: pil1, medio: pilmedio1 },
  { original: pil2, medio: pilmedio2 },
  { original: pil3, medio: pilmedio3 },
  { original: pil4, medio: pilmedio4 }
];
 */
// Componente para manejar el popup
/* const VideoPopup = ({ onClose }) => (
  <div className="popup-overlay" onClick={onClose}>
    <div className="popup-content">
      <iframe
        className="video-iframe-sos"
        src="https://www.youtube.com/embed/sFthYenWuL8?si=K1-3vqvtFoiDC5Vm"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
      <button className="close-button-video-sos" onClick={onClose}>
        <IoClose />
      </button>
    </div>
  </div>
); */

export default function Sostenibilidadvideo() {
  const [popupVisible, setPopupVisible] = useState(false);
  const [imagenSeleccionada, setImagenSeleccionada] = useState(null);

  const openPopup = useCallback(() => {
    setPopupVisible(true);
  }, []);

  const closePopup = useCallback(() => {
    setPopupVisible(false);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });

    return () => AOS.refresh(); // Cleanup AOS on component unmount
  }, []);

  const handleClicImagen = useCallback((index) => {
    setImagenSeleccionada(index === imagenSeleccionada ? null : index);
  }, [imagenSeleccionada]);

  return (
    <Container maxWidth="md" sx={{ marginTop: '0px', marginBottom: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <section className="video-sos" data-aos="fade-down">
        <h2>Nuestros Visión Estratégica</h2>

      <div className="imagen-pilar">
            <img src={nuevo} width="100%" height="100%" alt="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos" title="axinntus servicios, industriales, seguridad, mantenimiento, operación, equipos" data-aos="zoom-in-down" />
          </div>
      </section>


     
         
      
       
     
    </Container>
  );
}